// Formatação monetária no cliente - ESPELHO de FormatHelper#format_money.
//
// POR QUE EXISTE: quatro Stimulus controllers de preview reimplementavam a
// formatação por conta própria, e três deles fixavam "R$" e `toLocaleString("pt-BR")`
// no código. Com a moeda do app configurada para USD, o servidor renderizava
// "$1,234.56" e o preview do mesmo formulário renderizava "R$ 1.234,56" - símbolo,
// separadores e (em JPY/CLP) até o número de casas decimais divergindo na mesma tela.
//
// O meta da moeda vem do SERVIDOR via data-attribute (CURRENCY_META em
// FormatHelper), então não há tabela de moedas duplicada aqui: só o algoritmo.
//
// Uso no controller:
//   static values = { currency: Object }   // JSON do meta, vindo da view
//   formatMoney(cents, this.currencyValue)

const FALLBACK = { symbol: "R$", decimals: 2, thousands: ".", decimal: ",", space: " " }

// Agrupa milhares da direita para a esquerda ("1234567" → "1.234.567").
function groupThousands(digits, separator) {
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator)
}

// cents (Integer) → string formatada. Espelha exatamente o helper do servidor:
// símbolo + espaço opcional + sinal + corpo (o sinal fica DEPOIS do símbolo).
export function formatMoney(cents, meta) {
  const m = { ...FALLBACK, ...(meta || {}) }
  const decimals = Number.isInteger(m.decimals) ? m.decimals : 2

  const n = parseInt(cents, 10) || 0
  const sign = n < 0 ? "-" : ""
  const abs = Math.abs(n)

  let body
  if (decimals === 0) {
    body = groupThousands(String(abs), m.thousands)
  } else {
    const divisor = 10 ** decimals
    const whole = Math.floor(abs / divisor)
    const frac = String(abs % divisor).padStart(decimals, "0")
    body = `${groupThousands(String(whole), m.thousands)}${m.decimal}${frac}`
  }

  return `${m.symbol}${m.space}${sign}${body}`
}
